import { ButtonProps as MuiButtonProps } from "@material-ui/core/Button";
import {
    createStyles,
    WithStyles,
    withStyles,
    WithTheme,
} from "@material-ui/core/styles";
import * as React from "react";

import { Button, RelodeTheme } from "../";

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            padding: theme.spacing(2),
            height: "100%",
            flex: 1,
            display: "flex",
            flexDirection: "column",
        },
        input: {
            display: "none",
        },
        inputLabel: {
            display: "flex",
            flexDirection: "column",
            //alignItems: "center",
        },
        uploadButton: {
            display: "inline-flex",
            marginRight: theme.spacing(1),
        },
        uploadIcon: {
            marginRight: theme.spacing(1),
        },
    });

interface OwnProps extends WithStyles<typeof styles>, WithTheme {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    accept?: string;
    dataCy?: string;
}

export type FileUploadButtonProps = OwnProps & MuiButtonProps;

class FileUploadButtonClass extends React.Component<FileUploadButtonProps> {
    private fileInput = React.createRef<HTMLInputElement>();

    constructor(props: FileUploadButtonProps) {
        super(props);
    }

    clearFileInput = () => {
        if (this.fileInput.current) {
            this.fileInput.current.value = "";
        }
    };

    handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const { onChange } = this.props;

        if (onChange) {
            await onChange(event);
        }

        this.clearFileInput();
    };

    render() {
        const {
            children,
            classes,
            name,
            accept = ".docx",
            disabled = false,
            title = "upload",
            dataCy,
            ...buttonProps
        } = this.props;

        return (
            <label className={classes.inputLabel} data-cy="file-upload-button-label">
                <input
                    data-cy={dataCy}
                    ref={this.fileInput}
                    accept={accept}
                    className={classes.input}
                    type="file"
                    onChange={this.handleFileUpload}
                    name={name}
                    disabled={disabled}
                />
                <Button
                    component="span"
                    variant="contained"
                    className={classes.uploadButton}
                    disabled={disabled}
                    title={title}
                    {...buttonProps}
                >
                    {children}
                </Button>
            </label>
        );
    }
}

export const FileUploadButton = withStyles(styles, {
    name: "FileUploadButton",
    withTheme: true,
})(FileUploadButtonClass);
